import WarningAmberIcon from "@mui/icons-material/WarningAmberRounded";
import { Tooltip, Typography } from "@mui/material";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

interface BadgeProps {
	statusCode: string;
	statusName?: string;
	requestSubStatusCode?: string;
}

const Badge: FC<BadgeProps> = ({
	statusCode,
	statusName,
	requestSubStatusCode = "",
}) => {
	const { t } = useTranslation();
	const statusColor = {
		p: "#70491C",
		a: "#002D9C",
		r: "#750E13",
		w: "#000000",
		aa: "#002D9C",
	};

	const backgroundColor = {
		p: "#FAF6CF",
		a: "#D0E2FF",
		r: "#FFD7D9",
		w: "#F0F0F0",
		aa: "#D0E2FF",
	};

	const statusNameModified = {
		p: t("worker-requests_status-pending"),
		a: t("worker-requests_status-approved"),
		r: t("worker-requests_status-declined"),
		w: t("worker-requests_status-cancelled"),
		aa: t("worker-requests_status-auto-approved"),
	};

	const tooltipText = (
		<span style={{ whiteSpace: "pre-line" }}>
			{t("worker-requests_insufficient-balance-tooltip")}
		</span>
	);

	const isStatusRelevant = ["p", "a"].includes(statusCode);
	const isSubStatusRelevant = ["ae", "pb"].includes(requestSubStatusCode);
	const showWarningIcon = isStatusRelevant && isSubStatusRelevant;


	return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: "20px",
        padding: "2px 4px",
        borderRadius: "4px",
        backgroundColor:
          backgroundColor[statusCode as keyof typeof backgroundColor],
        color: statusColor[statusCode as keyof typeof statusColor],
        fontSize: "12px",
        fontWeight: "bold",
        width: "fit-content",
        gap: "4px",
      }}
    >
      <div style={{ padding: "0 2px" }}>
        {statusNameModified[statusCode as keyof typeof statusNameModified] ??
          statusName}
      </div>

      {showWarningIcon && (
        <Tooltip title={tooltipText} disableInteractive>
          <div
            style={{
              width: "16px",
              height: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <WarningAmberIcon sx={{ color: "#E65100", fontSize: 16 }} />
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default Badge;
